export const JWT_PREFIX = 'Bearer';
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const SWAGGER_URL = process.env.REACT_APP_SWAGGER_URL;
export const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY;
export const PARTNER_KEY = process.env.REACT_APP_PARTNER_KEY;
export const CAPTCHA_KEY = process.env.REACT_APP_CAPTCHA_KEY || 'N/A';
export const SWAGGER_LOGIN = 'indigo';
export const SWAGGER_PWD = 'NuF/5&UT';
export const CAPTCHA_ATTEMPTS_LIMIT = 3;
